import { render } from "./PResetPasswords.vue?vue&type=template&id=2961d0f0&scoped=true"
import script from "./PResetPasswords.vue?vue&type=script&lang=js"
export * from "./PResetPasswords.vue?vue&type=script&lang=js"

import "./PResetPasswords.vue?vue&type=style&index=0&id=2961d0f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2961d0f0"]])

export default __exports__